var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.64645 13.3536C7.84171 13.5488 8.15829 13.5488 8.35355 13.3536L11.5355 10.1716C11.7308 9.97631 11.7308 9.65973 11.5355 9.46447C11.3403 9.2692 11.0237 9.2692 10.8284 9.46447L8 12.2929L5.17157 9.46447C4.97631 9.2692 4.65973 9.2692 4.46447 9.46447C4.2692 9.65973 4.2692 9.97631 4.46447 10.1716L7.64645 13.3536ZM7.5 4V13H8.5V4H7.5Z",
    fill: "#E8F2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.354eb0a6dfc48e9f5144371b0674de67.svg";
export { ForwardRef as ReactComponent };